function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as Y from 'yjs';
import { ElementModel } from './ElementModel';
import { EditorConfig } from '../../edit/EditorConfig';
export class TriangleModel extends ElementModel {
  get drawPoints() {
    if (this.localPoints.length >= 6) {
      return this.localPoints;
    }
    return this.points;
  }
  constructor(root, scope, liveCursor, isPerformanceMode) {
    super(root, scope, liveCursor, isPerformanceMode);
    _defineProperty(this, "item", null);
    _defineProperty(this, "clearLocalPointsWhenYPointsChange", true);
    _defineProperty(this, "shouldUseLocalPoints", true);
    _defineProperty(this, "localPointsPick", 6);
    if (this.root.doc && !this.root.has('type')) {
      this.root.set('type', 'triangle');
    }
    if (this.root.doc && !this.root.has('points')) {
      this.root.set('points', new Y.Array());
    }
  }
  liveCursorPoint() {
    const yArray = this.root.get(ElementModel.KEYS.points);
    if (yArray.length < 6) {
      return null;
    }
    const len = yArray.length;
    const point = new this.scope.Point(yArray.get(len - 4), yArray.get(len - 3));
    return point.transform(new this.scope.Matrix(this.pointsMatrix));
  }
  subDispose() {}
  createPaperItem() {
    this.item = new this.scope.Path();
    this.item.strokeCap = 'butt';
    this.item.strokeJoin = 'round';
    this.item.strokeColor = new this.scope.Color(this.strokeColor);
    this.item.dashArray = this.dashArray;
    this.item.strokeWidth = this.strokeWidth;
    if (this.fillColor && this.fillColor.length > 0) {
      this.item.fillColor = new this.scope.Color(this.fillColor);
    }
    this.onVectorUpdate();
  }
  onVectorUpdate() {
    if (!this.item) {
      return;
    }
    const matrix = new this.scope.Matrix(this.pointsMatrix);
    const p1 = new this.scope.Point(this.drawPoints[0], this.drawPoints[1]).transform(matrix);
    const p2 = new this.scope.Point(this.drawPoints[2], this.drawPoints[3]).transform(matrix);
    const p3 = new this.scope.Point(this.drawPoints[4], this.drawPoints[5]).transform(matrix);
    this.item.removeSegments();
    this.item.moveTo(p1);
    this.item.lineTo(p2);
    this.item.lineTo(p3);
    this.item.closePath();
  }
  editorConfig() {
    const config = new EditorConfig();
    config.controlPoints.push({
      name: 'triangle',
      getPosition: () => {
        const point = new this.scope.Point(this.drawPoints[0], this.drawPoints[1]);
        const pointsMatrix = new this.scope.Matrix(this.pointsMatrix);
        return this.scope.project.view.projectToView(point.transform(pointsMatrix));
      },
      onPositionChange: point => {
        if (!this.item) {
          return;
        }
        const pointsMatrix = new this.scope.Matrix(this.pointsMatrix);
        const trPoint = point.transform(pointsMatrix.inverted());
        const oldPoints = this.drawPoints;
        this.setPoints([trPoint.x, trPoint.y, oldPoints[2], oldPoints[3], oldPoints[4], oldPoints[5]]);
      }
    });
    return config;
  }
  vectorKeys() {
    return [];
  }
  styleKeys() {
    return {
      include: [],
      exclude: []
    };
  }
  onStyleKeyUpdate(_key) {}
}